import { createApp } from 'vue'
import Fractions from './Fractions.vue'
import './assets/global.css'

createApp(Fractions).mount('#fractions')
